/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import {
    VirtualServiceStateService,
} from 'ng/modules/virtual-service/services/virtual-service-state.service';
import { VsLogListExpandedContentStore } from '../vs-log-list-expanded-content.store';
import { VsLogsStore } from '../../../../services/vs-logs.store';
import { VsAppProfileType } from '../../../../vs-logs.types';

import * as l10n from './vs-log-communicating-ips.component.l10n';
import './vs-log-communicating-ips.component.less';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component used for showing the communicating IPs in the log list expanded content.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'vs-log-communicating-ips',
    templateUrl: 'vs-log-communicating-ips.component.html',
})
export class VsLogCommunicatingIpsComponent {
    public readonly globalL10nKeys = globalL10nKeys;

    public readonly l10nKeys = l10nKeys;

    public readonly vsAppProfileType$ = this.vsLogsStore.vsAppProfileType$;

    public readonly VsAppProfileType = VsAppProfileType;

    public readonly clientRtt$ = this.vsLogListExpandedContentStore.clientRtt$;

    public readonly serverRtt$ = this.vsLogListExpandedContentStore.serverRtt$;

    public readonly responseCode$ = this.vsLogListExpandedContentStore.responseCode$;

    public readonly serverResponseCode$ = this.vsLogListExpandedContentStore.serverResponseCode$;

    public readonly appResponseTime$ = this.vsLogListExpandedContentStore.appResponseTime$;

    public readonly dataTransferTime$ = this.vsLogListExpandedContentStore.dataTransferTime$;

    public readonly totalTime$ = this.vsLogListExpandedContentStore.totalTime$;

    public readonly clientIps$ = this.vsLogListExpandedContentStore.clientIps$;

    public readonly clientSrcPort$ = this.vsLogListExpandedContentStore.clientSrcPort$;

    public readonly clientDestPort$ = this.vsLogListExpandedContentStore.clientDestPort$;

    public readonly vsIps$ = this.vsLogListExpandedContentStore.vsIps$;

    public readonly serverIps$ = this.vsLogListExpandedContentStore.serverIps$;

    public readonly serverSrcPort$ = this.vsLogListExpandedContentStore.serverSrcPort$;

    public readonly serverDestPort$ = this.vsLogListExpandedContentStore.serverDestPort$;

    public readonly sourceIps$ = this.vsLogListExpandedContentStore.sourceIps$;

    public readonly serverConnectionSrcIps$ =
        this.vsLogListExpandedContentStore.serverConnectionSrcIps$;

    public readonly serviceEngine$ = this.vsLogListExpandedContentStore.serviceEngine$;

    public readonly vcpuId$ = this.vsLogListExpandedContentStore.vcpuId$;

    public readonly pool$ = this.vsLogListExpandedContentStore.pool$;

    public readonly poolName$ = this.vsLogListExpandedContentStore.poolName$;

    public readonly serverName$ = this.vsLogListExpandedContentStore.serverName$;

    /**
     * Reference to the virtual service item instance.
     */
    public readonly vs: any;

    constructor(
        l10nService: L10nService,
        vsStateService: VirtualServiceStateService,
        private readonly vsLogsStore: VsLogsStore,
        public readonly vsLogListExpandedContentStore: VsLogListExpandedContentStore,
    ) {
        l10nService.registerSourceBundles(dictionary);

        this.vs = vsStateService.virtualService;
    }
}
